import { call, fork, put, select, take, takeLatest } from "redux-saga/effects";

import { bridge, createApplyThemeAction, createLoadLocalStorageKeyAction, createSetLocalStorageKeyAction, ILocalStorageKeyLoadedAction } from "@multiweb/reactCore/bridge";
import { SagaWithReturnType } from "@multiweb/types/react";
import { ApplicationTheme } from "@multiweb/uiShared/ApplicationTheme";
import { createSetThemeAction } from "./actions";
import { LOCAL_STORAGE_THEME_KEY, TOGGLE_THEME } from "./constants";
import { getOtherTheme } from "./selectors";
import { isApplicationThemeValid } from "./utils";

const { createIsLocalStorageKeyLoadedActionPattern } = bridge;

export const saga: SagaWithReturnType = function* themeSaga() {
    yield takeLatest(TOGGLE_THEME, toggleThemeSaga);
    yield fork(loadThemeSaga);
};

/**
 * Obsluhuje načtení tématu aplikace a jeho uložení do stavu.
 */
export const loadThemeSaga: SagaWithReturnType = function* loadThemeSaga() {
    yield put(createLoadLocalStorageKeyAction(LOCAL_STORAGE_THEME_KEY));
    const action: ILocalStorageKeyLoadedAction = yield take(createIsLocalStorageKeyLoadedActionPattern(LOCAL_STORAGE_THEME_KEY));
    const { value } = action.payload;
    if (yield call(isApplicationThemeValid, value)) {
        yield put(createSetThemeAction(value as ApplicationTheme));
    }
};

/**
 * Obsluhuje přepnutí tématu aplikace a jeho uložení do stavu.
 * Změnu projeví do původní části aplikace a nastaví hodnotu tématu v local storage.
 */
export const toggleThemeSaga: SagaWithReturnType = function* toggleThemeSaga() {
    const otherTheme: ReturnType<typeof getOtherTheme> = yield select(getOtherTheme);
    yield put(createSetLocalStorageKeyAction(LOCAL_STORAGE_THEME_KEY, otherTheme));
    yield put(createApplyThemeAction(otherTheme));
    yield put(createSetThemeAction(otherTheme));
};
